<template>
    <div>
        <div class="px-4">
            <div>
                <v-row>
                    <entity-select-input
                        v-model="companyId"
                        v-validate="''"
                        label="labels.companies"
                        name="companies"
                        :entity="selectApiClientType.COMPANY"
                        :query-params="{ can_be_admin: true }"
                        autocomplete
                        :data-vv-as="$t('labels.companies')"
                        @input="setType('company', true)"
                    ></entity-select-input>

                    <entity-select-input
                        v-model="restaurantId"
                        v-validate="''"
                        label="labels.restaurants"
                        name="restaurants"
                        :entity="selectApiClientType.RESTAURANT"
                        :query-params="{ can_be_admin: true }"
                        autocomplete
                        :data-vv-as="$t('labels.restaurants')"
                        @input="setType('restaurant', true)"
                    ></entity-select-input>
                </v-row>
            </div>
            <div class="my-3">
                <v-row>
                    <v-btn
                        tile
                        color="success"
                        class="mx-1 rounded"
                        :disabled="!myEntityId"
                        @click="openFolderModal"
                    >
                        <v-icon left>create_new_folder </v-icon>
                        {{ $t('invoices.new_folder') }}
                    </v-btn>
                    <div>
                        <v-btn
                            tile
                            color="primary"
                            class="mx-1 rounded"
                            rounded
                            :disabled="!currentFolder"
                            @click="onButtonClick"
                        >
                            <v-icon left> upload_file </v-icon>
                            {{ $t('invoices.upload_file') }}
                        </v-btn>
                        <input
                            ref="uploader"
                            class="d-none"
                            type="file"
                            accept=""
                            multiple
                            @change="onFileChanged"
                        />
                    </div>
                </v-row>
            </div>
        </div>
        <div>
            <v-card elevation="0" class="mb-4 border-g-e8">
                <v-card-text>
                    <template>
                        <v-breadcrumbs :items="breadcrumbs">
                            <template v-slot:item="{ item }">
                                <v-breadcrumbs-item :disabled="true">
                                    {{ item.text.toUpperCase() }}
                                </v-breadcrumbs-item>
                            </template>
                        </v-breadcrumbs>
                    </template>
                    <v-list-item-group>
                        <template v-if="!currentFolder">
                            <v-list-item
                                v-for="folder in folders"
                                :key="folder.id"
                                @click="setPath(folder)"
                            >
                                <v-list-item-icon>
                                    <v-icon>folder</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title
                                        v-text="folder.text"
                                    ></v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <div>
                                        <v-btn
                                            icon
                                            @click="
                                                (e) =>
                                                    openFolderRenameModal(
                                                        e,
                                                        folder
                                                    )
                                            "
                                        >
                                            <v-icon color="grey lighten-1"
                                                >edit</v-icon
                                            >
                                        </v-btn>
                                        <v-btn
                                            icon
                                            @click="
                                                (e) =>
                                                    deleteFolder(e, folder.id)
                                            "
                                        >
                                            <v-icon color="grey lighten-1"
                                                >delete</v-icon
                                            >
                                        </v-btn>
                                    </div>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                        <template v-if="currentFolder">
                            <v-list-item :key="0" @click="load()">
                                <v-list-item-icon>
                                    <v-icon>folder</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>..</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-for="file in files" :key="file.id">
                                <v-list-item-icon>
                                    <v-icon>description</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title
                                        v-text="
                                            file.file_name +
                                            '.' +
                                            file.extension
                                        "
                                    ></v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <div>
                                        <v-btn
                                            icon
                                            @click="
                                                (e) =>
                                                    openFileRenameModal(e, {
                                                        id: file.id,
                                                        text: file.file_name,
                                                    })
                                            "
                                        >
                                            <v-icon color="grey lighten-1"
                                                >edit</v-icon
                                            >
                                        </v-btn>
                                        <v-btn
                                            icon
                                            @click="
                                                downloadFile(
                                                    file.id,
                                                    file.file_name
                                                )
                                            "
                                        >
                                            <v-icon color="grey lighten-1"
                                                >file_download</v-icon
                                            >
                                        </v-btn>
                                        <v-btn
                                            icon
                                            @click="deleteFile(file.id)"
                                        >
                                            <v-icon color="grey lighten-1"
                                                >delete</v-icon
                                            >
                                        </v-btn>
                                    </div>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-card-text>
            </v-card>
        </div>
        <overlay :show="busy">
            <template>
                <slot></slot>
            </template>
        </overlay>
        <folder-modal
            :value.sync="dialog"
            :title="$t('invoices.create_new_folder')"
            :approve-text="$t('invoices.create')"
            approve-color="green"
            @onCancel="hideModal"
            @onApprove="createFolder"
        ></folder-modal>
        <folder-modal
            :value.sync="dialogModify"
            :title="$t('invoices.rename_folder')"
            :approve-text="$t('invoices.rename')"
            approve-color="green"
            :input-value="inputValue"
            @onCancel="hideFolderRenameModal"
            @onApprove="modifyFolder"
        ></folder-modal>
        <folder-modal
            :value.sync="dialogModifyFile"
            :title="$t('invoices.rename_file')"
            :approve-text="$t('invoices.rename')"
            approve-color="green"
            :input-value="inputValue"
            @onCancel="hideFileRenameModal"
            @onApprove="modifyFile"
        ></folder-modal>
    </div>
</template>

<script>
import ApiClientType from '@/api/RestApiType'
import FormExtend from '@/components/mixins/FormExtend'
import AuthMixin from '@/components/mixins/AuthMixin'
import RestApiCollection from '@/api/RestApiCollection'
import IdFromIri from '@/services/IdFromIri'
import SelectApiClientType from '@/api/SelectApiClientType'
import FolderModal from '@/components/confirm/FolderModal'
import EntitySelectInput from '@/components/form/Inputs/EntitySelectInput'
import Overlay from '@/components/overlay/Overlay'

export default {
    components: {
        FolderModal,
        EntitySelectInput,
        Overlay,
    },
    mixins: [FormExtend, AuthMixin],
    props: {
        itemid: {
            type: String,
            default: null,
        },
        itemtype: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            api: ApiClientType.COMPANY_INVOICE,
            selectApiClientType: SelectApiClientType,
            dialog: false,
            dialogModify: false,
            dialogModifyFile: false,
            busy: false,
            type: null,
            companyId: null,
            restaurantId: null,
            parentFolderId: null,
            currentFolder: null,
            folders: [],
            files: [],
            selectedFile: null,
            isSelecting: false,
            inputValue: null,
        }
    },
    computed: {
        myEntityId: function () {
            return this.companyId
                ? IdFromIri.getId(this.companyId)
                : IdFromIri.getId(this.restaurantId)
        },
        breadcrumb: function () {
            return this.currentFolder ? this.currentFolder.text : null
        },
        breadcrumbs: function () {
            return this.currentFolder ? [this.currentFolder] : []
        },
    },
    created() {
        if (this.itemid == null) return

        if (this.itemtype === 'company') {
            this.companyId = `/api/v1/companies/${this.itemid}`
        } else if (this.itemtype === 'restaurant') {
            this.restaurantId = `/api/v1/restaurants/${this.itemid}`
        }
        this.setType(this.itemtype, false)
    },
    methods: {
        openFolderModal() {
            this.dialog = true
        },
        hideModal() {
            this.dialog = false
        },
        openFolderRenameModal(e, inputValue) {
            e.stopPropagation()
            this.inputValue = inputValue
            this.dialogModify = true
        },
        hideFolderRenameModal() {
            this.dialogModify = false
        },
        openFileRenameModal(e, inputValue) {
            e.stopPropagation()
            this.inputValue = inputValue
            this.dialogModifyFile = true
        },
        hideFileRenameModal() {
            this.dialogModifyFile = false
        },
        setType(value, redirect) {
            this.folders = []
            this.files = []
            this.currentFolder = null
            if (
                value == 'restaurant' &&
                typeof this.restaurantId != 'undefined'
            ) {
                this.companyId = null
                if (redirect) {
                    this.$router.push({
                        path: `/invoices/restaurants/${this.myEntityId}`,
                    })
                }
                this.type = value
                this.load()
            } else if (
                value == 'company' &&
                typeof this.companyId != 'undefined'
            ) {
                this.restaurantId = null
                if (redirect) {
                    this.$router.push({
                        path: `/invoices/companies/${this.myEntityId}`,
                    })
                }
                this.type = value
                this.load()
            }
        },
        modifyFolder(folderName, folderId) {
            this.busy = true
            RestApiCollection.get(this.api)
                .modifyFolder(this.type, this.myEntityId, folderId, folderName)
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                    this.hideFolderRenameModal()
                    this.load()
                    this.busy = false
                })
        },
        modifyFile(fileName, fileId) {
            this.busy = true
            RestApiCollection.get(this.api)
                .modifyFile(
                    this.type,
                    this.myEntityId,
                    this.currentFolder.id,
                    fileId,
                    fileName
                )
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                    this.hideFileRenameModal()
                    this.loadFolderFiles(this.currentFolder.id)
                    this.busy = false
                })
        },
        setPath(folder) {
            folder?.id
                ? (this.loadFolderFiles(folder.id),
                  (this.currentFolder = folder))
                : (this.currentFolder = null)
        },
        onButtonClick() {
            this.isSelecting = true
            window.addEventListener(
                'focus',
                () => {
                    this.isSelecting = false
                },
                { once: true }
            )

            this.$refs.uploader.click()
        },
        async onFileChanged(e) {
            this.selectedFile = e.target.files
            const form = new FormData()
            form.append('file', this.selectedFile[0])
            form.append(
                'title',
                this.selectedFile[0].name.substring(
                    0,
                    this.selectedFile[0].name.lastIndexOf('.')
                )
            )
            this.upload(form)
        },
        upload(file) {
            this.busy = true
            RestApiCollection.get(this.api)
                .uploadFiles(
                    this.type,
                    this.myEntityId,
                    this.currentFolder.id,
                    file
                )
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                    this.loadFolderFiles(this.currentFolder.id)
                    this.busy = false
                })
        },
        load() {
            this.busy = true
            this.files = []
            this.folders = []
            this.currentFolder = null
            RestApiCollection.get(this.api)
                .getFolders(this.type, this.myEntityId)
                .then((data) => {
                    this.folders = data
                })
                .catch(() => {})
                .finally(() => {
                    this.busy = false
                })
        },
        loadFolderFiles(folderId) {
            this.busy = true
            RestApiCollection.get(this.api)
                .getFolderFiles(this.type, this.myEntityId, folderId)
                .then((data) => {
                    this.files = data
                })
                .catch(() => {})
                .finally(() => {
                    this.busy = false
                })
        },
        deleteFile(fileId) {
            this.busy = true
            RestApiCollection.get(this.api)
                .deleteFile(
                    this.type,
                    this.myEntityId,
                    this.currentFolder.id,
                    fileId
                )
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                    this.loadFolderFiles(this.currentFolder.id)
                    this.busy = false
                })
        },
        deleteFolder(e, folderId) {
            e.stopPropagation()
            this.busy = true
            RestApiCollection.get(this.api)
                .deleteFolder(this.type, this.myEntityId, folderId)
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                    this.load()
                    this.busy = false
                })
        },
        createFolder(val) {
            this.busy = true
            RestApiCollection.get(this.api)
                .createFolder(this.type, this.myEntityId, null, val)
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                    this.hideModal()
                    this.load()
                    this.busy = false
                })
        },
        downloadFile(fileId, fileName) {
            this.busy = true
            RestApiCollection.get(this.api)
                .downloadFile(
                    this.type,
                    this.myEntityId,
                    this.currentFolder.id,
                    fileId
                )
                .then((response) => {
                    const blob = new Blob([response], {
                        type: 'application/pdf',
                    })
                    const blobUrl = URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = blobUrl
                    link.download = fileName
                    link.click()
                    URL.revokeObjectURL(link.href)
                })
                .catch(() => {})
                .finally(() => {
                    this.busy = false
                })
        },
    },
}
</script>
